module.exports = __webpack_public_path__ + "img/victoria.6cbfe0a6.jpg";